import { useEffect } from 'react';
import mapsUrl from 'utils/mapsUrl';

// Lightweight, theme-agnostic modal listing every branch's full address.
// Used by the public templates' footers so the footer can stay compact
// (name → Maps link) while full addresses live behind a "View full addresses" button.
export default function AddressesModal({ open, onClose, locations = [], accent = '#0D9488' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 4000, background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', color: '#1a1a1a', width: '100%', maxWidth: 460,
          maxHeight: '82vh', borderRadius: 16, overflow: 'hidden',
          display: 'flex', flexDirection: 'column', boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
          <div style={{ fontWeight: 700, fontSize: '1rem' }}>
            {locations.length === 1 ? 'Our Location' : `Our Locations (${locations.length})`}
          </div>
          <button aria-label="Close" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.5rem', lineHeight: 1, color: '#666', padding: 4 }}>×</button>
        </div>

        <div style={{ overflowY: 'auto', padding: '8px 20px 20px' }}>
          {locations.map((l, idx) => {
            const isObj = typeof l === 'object' && l !== null;
            const nm = isObj ? (l.name || `Branch ${idx + 1}`) : l;
            const addr = isObj ? l.address : '';
            const ph = isObj ? l.phone : '';
            return (
              <div key={isObj && l.id ? l.id : idx} style={{ padding: '14px 0', borderBottom: idx < locations.length - 1 ? '1px solid rgba(0,0,0,0.07)' : 'none' }}>
                <div style={{ fontWeight: 700, fontSize: '0.95rem', marginBottom: 4 }}>📍 {nm}</div>
                {addr && <div style={{ fontSize: '0.86rem', color: '#555', lineHeight: 1.5 }}>{addr}</div>}
                <div style={{ display: 'flex', gap: 16, marginTop: 8, flexWrap: 'wrap' }}>
                  <a href={mapsUrl(l)} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.82rem', fontWeight: 600, color: accent, textDecoration: 'none' }}>
                    Open in Maps →
                  </a>
                  {ph && <a href={`tel:${ph}`} style={{ fontSize: '0.82rem', fontWeight: 600, color: accent, textDecoration: 'none' }}>📞 {ph}</a>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
